import { useCallback } from 'react';
import { Modal, notification } from 'antd';
import { getFetchErrorDetail } from '@/shared/utils/rtkError';

interface DeleteRequest {
  unwrap: () => Promise<unknown>;
}

/** Ask before deleting a row. `noun` is in title case, e.g. "Report Template". */
export function useConfirmDelete(
  noun: string,
  remove: (uuid: string) => DeleteRequest
) {
  const lower = noun.toLowerCase();
  return useCallback(
    ({ uuid, name }: { uuid: string; name: string }) => {
      Modal.confirm({
        title: `Delete ${noun}`,
        content: `Are you sure you want to delete "${name}"? This action cannot be undone.`,
        okText: 'Delete',
        okButtonProps: { danger: true },
        onOk: async () => {
          try {
            await remove(uuid).unwrap();
            notification.success({
              title: `${noun[0]}${lower.slice(1)} deleted`,
            });
          } catch (err) {
            // The backend explains why, e.g. it's the standard or someone's default.
            notification.error({
              title: `Failed to delete ${lower}`,
              description: getFetchErrorDetail(err),
            });
          }
        },
      });
    },
    [noun, lower, remove]
  );
}
